import { Link } from 'react-router-dom';
import { brand } from '../content/site';
import { useLocale, localizedPath, useMessages } from '../i18n/locale';

export default function Brand() {
  const locale = useLocale();
  const copy = useMessages().brand;
  return (
    <Link
      className="brand"
      to={localizedPath(locale)}
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      aria-label={`${brand.name} ${copy.homeLabel}`}
    >
      <span className="brand-mark" aria-hidden="true">
        <img src={`${process.env.PUBLIC_URL}/brand-logo.png`} alt="" width="26" height="26" />
      </span>
      <span>{brand.name}</span>
    </Link>
  );
}
